import { j as t } from "./jsx-runtime-DmTjM30f.mjs";
import { useRef as k, useState as w, useEffect as C } from "react";
import { I, a as z } from "./ic_arrowforward_fill-DIQoCdSY.mjs";
import { createPortal as B } from "react-dom";
import { F as b } from "./floating-button-XxUwMo0R.mjs";
import { c as j } from "./tw-cn-mXgPecoF.mjs";
const T = (y) => {
  const { id: p, hidden: u, size: m, top: x, arrowProps: E, zIndex: f = 120, positionStrategy: d = "absolute" } = y, { left: e, right: o } = E || {}, n = d === "fixed", a = x !== void 0, i = k(null), [r, g] = w({ top: 0, left: 0, width: 0, height: 0 }), [F, P] = w(!0), h = () => {
    if (a) return `${x}px`;
    if (n) return `${r.top + r.height / 2}px`;
  };
  return C(() => {
    var v;
    i.current = document.getElementById(p);
    const s = (v = i.current) == null ? void 0 : v.parentElement;
    if (!i.current || !s) {
      P(!1);
      return;
    }
    const l = () => {
      if (i.current) {
        const c = i.current.getBoundingClientRect();
        g({
          top: c.top + window.scrollY,
          left: c.left + window.scrollX,
          width: c.width,
          height: c.height
        });
      }
    };
    if (l(), !!n)
      return s.addEventListener("resize", l), s.addEventListener("scroll", l), () => {
        s.removeEventListener("resize", l), s.removeEventListener("scroll", l);
      };
  }, [p, u]), B(
    /* @__PURE__ */ t.jsx(t.Fragment, { children: !u && F ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      !(e != null && e.hidden) && /* @__PURE__ */ t.jsx(
        "div",
        {
          className: j("-translate-x-1/2", {
            "top-1/2 -translate-y-1/2": !a
          }),
          style: {
            position: d,
            zIndex: f,
            top: h(),
            left: n ? `${r.left}px` : 0
          },
          children: /* @__PURE__ */ t.jsx(
            b,
            {
              disabled: !!(e != null && e.disabled),
              icon: /* @__PURE__ */ t.jsx(I, {}),
              onClick: e == null ? void 0 : e.onClick,
              size: m
            }
          )
        }
      ),
      !(o != null && o.hidden) && /* @__PURE__ */ t.jsx(
        "div",
        {
          className: j("translate-x-1/2", {
            "top-1/2 -translate-y-1/2": !a,
            "-translate-x-1/2": n
          }),
          style: {
            position: d,
            zIndex: f,
            top: h(),
            left: n ? `${r.left + r.width}px` : void 0,
            right: n ? void 0 : 0
          },
          children: /* @__PURE__ */ t.jsx(
            b,
            {
              disabled: !!(o != null && o.disabled),
              icon: /* @__PURE__ */ t.jsx(z, {}),
              onClick: o == null ? void 0 : o.onClick,
              size: m
            }
          )
        }
      )
    ] }) : null }),
    n ? document.body : i.current || document.body
  );
};
export {
  T as S
};
